// Avertissement avant d'afficher une adresse probable : montré tant que l'utilisateur n'a pas coché « Ne plus me
// prévenir », retenu dans ce navigateur seulement. Sans stockage utilisable, on prévient toujours.
type Storage = Pick<globalThis.Storage, "getItem" | "setItem">;

const KEY = "radar.probable_email.no_warning";

export const warnBeforeProbable = (storage: Storage | null) => {
  try {
    return storage?.getItem(KEY) !== "1";
  } catch {
    return true;
  }
};

export const skipProbableWarning = (storage: Storage | null) => {
  try {
    storage?.setItem(KEY, "1");
  } catch {
    // Stockage refusé : l'avertissement reviendra, rien de plus.
  }
};

export const browserStorage = (): Storage | null => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};
